(() => {
  /* =========================================================
     PREVENT DOUBLE LOAD
  ========================================================= */
  if (window.__pfp_protect6_loaded) return;
  window.__pfp_protect6_loaded = true;

  /* =========================================================
   MODAL (works after section refresh)
   - scripts inside sections won't execute after innerHTML replace
   - so we bind once on document, using delegation
========================================================= */
(() => {
  if (window.__pfp_protect6_modal_bound) return;
  window.__pfp_protect6_modal_bound = true;

  const lockScroll = () => {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  };

  const unlockScroll = () => {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  };

  const openModal = () => {
  const modal = document.querySelector('[data-protect6-modal]');
  if (!modal) return;

  // Scroll to top BEFORE locking scroll (use valid value: 'auto' or 'smooth')
  window.scrollTo({ top: 0, behavior: 'auto' });

  // Wait 1 frame so scroll applies, then open + lock
  requestAnimationFrame(() => {
    modal.setAttribute('aria-hidden', 'false');
    lockScroll();

    const panel = modal.querySelector('.pfp-modal__panel');
    if (panel) panel.focus({ preventScroll: true });
  });
};


  const closeModal = () => {
    const modal = document.querySelector('[data-protect6-modal]');
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    unlockScroll();
  };

  document.addEventListener('click', (e) => {
    // OPEN
    if (e.target.closest('[data-protect6-covered-btn]')) {
      e.preventDefault();
      openModal();
      return;
    }

    // CLOSE (backdrop or X)
    if (e.target.closest('[data-protect6-modal-close]')) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const modal = document.querySelector('[data-protect6-modal]');
    if (modal && modal.getAttribute('aria-hidden') === 'false') closeModal();
  });

  // Safety: if the modal element gets re-rendered open, close it
  document.addEventListener('cart:refresh', () => {
    const modal = document.querySelector('[data-protect6-modal]');
    if (modal && modal.getAttribute('aria-hidden') === 'false') closeModal();
  });
})();


  /* =========================================================
     CONFIG
  ========================================================= */
  const EXCLUDED_PRODUCT_TYPES = new Set(['Accessories', 'Accessory']);

  // values are in PENCE
  const WARRANTY_TIERS = [
    { min: 0,       max: 49999,    variantId: 57014574711109, label: '£50'  },
    { min: 50000,   max: 99999,    variantId: 57014574743877, label: '£90 - Includes Free Care Kit' },
    { min: 100000,  max: 149999,   variantId: 57014574776645, label: '£110 - Includes Free Care Kit' },
    { min: 150000,  max: 199999,   variantId: 57014574809413, label: '£130 - Includes Free Care Kit' },
    { min: 200000,  max: 299999,   variantId: 57014574842181, label: '£170 - Includes Free Care Kit' },
    { min: 300000,  max: 399999,   variantId: 57014574874949, label: '£190 - Includes Free Care Kit' },
    { min: 400000,  max: 499999,   variantId: 57014574907717, label: '£210 - Includes Free Care Kit' },
    { min: 500000,  max: 999999,   variantId: 57014574940485, label: '£230 - Includes Free Care Kit' },
    { min: 1000000, max: 1999999,  variantId: 57014574973253, label: '£270 - Includes Free Care Kit' }
  ];

  const WARRANTY_IDS = new Set(WARRANTY_TIERS.map(t => String(t.variantId)));

  


  /* =========================================================
     HELPERS
  ========================================================= */
  const fetchJson = async (url, opts = {}) => {
    const res = await fetch(url, { credentials: 'same-origin', ...opts });
    if (!res.ok) {
      let msg = '';
      try { msg = await res.text(); } catch (_) {}
      throw new Error(`${url} failed (${res.status}) ${msg}`);
    }
    try { return await res.json(); } catch (_) { return null; }
  };

  const getCart = async () => fetchJson('/cart.js');

  // IMPORTANT: use line item KEY for change
  const changeByKey = async (key, qty) => {
    await fetchJson('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: Number(qty) })
    });
  };

  const addVariant = async (variantId) => {
    await fetchJson('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });
  };

  // detect warranty lines reliably (apps may populate id vs variant_id differently)
  const isWarrantyLine = (item) => {
    const a = String(item?.id ?? '');
    const b = String(item?.variant_id ?? '');
    return WARRANTY_IDS.has(a) || WARRANTY_IDS.has(b);
  };

  const getProtectItems = (cart) => (cart.items || []).filter(isWarrantyLine);

  const getEligibleSubtotal = (cart) => {
    let total = 0;
    for (const item of (cart.items || [])) {
      if (isWarrantyLine(item)) continue;
      const pt = (item.product_type || '').trim();
      if (EXCLUDED_PRODUCT_TYPES.has(pt)) continue;
      total += (item.final_line_price ?? item.line_price ?? 0);
    }
    return total;
  };

  const hasEligibleFurniture = (cart) => {
    return (cart.items || []).some(item => {
      if (isWarrantyLine(item)) return false;
      const pt = (item.product_type || '').trim();
      return !EXCLUDED_PRODUCT_TYPES.has(pt);
    });
  };

  const findTier = (subtotal) =>
    WARRANTY_TIERS.find(t => subtotal >= t.min && subtotal <= t.max) || WARRANTY_TIERS[0];

  const removeAllWarranty = async (cart) => {
    const lines = getProtectItems(cart);
    for (const w of lines) await changeByKey(w.key, 0);
  };

  /* =========================================================
     SECTION REFRESH (NO FULL PAGE RELOAD)
     - refreshes main-cart-items + footer totals
     - avoids white flash
  ========================================================= */
  const refreshCartPage = async () => {
    const res = await fetch('/?sections=main-cart-items,main-cart-footer', {
      credentials: 'same-origin'
    });
    if (!res.ok) return;

    const data = await res.json().catch(() => null);
    if (!data) return;

    // Replace cart items contents only
    if (data['main-cart-items']) {
      const tmp = document.createElement('div');
      tmp.innerHTML = data['main-cart-items'];

      const newContents = tmp.querySelector('#main-cart-items .js-contents');
      const curContents = document.querySelector('#main-cart-items .js-contents');

      if (newContents && curContents) {
        curContents.innerHTML = newContents.innerHTML;
      }
    }

    // Replace footer section
    if (data['main-cart-footer']) {
      const tmp = document.createElement('div');
      tmp.innerHTML = data['main-cart-footer'];

      const newFooter = tmp.querySelector('#shopify-section-main-cart-footer');
      const curFooter = document.querySelector('#shopify-section-main-cart-footer');

      if (newFooter && curFooter) {
        curFooter.innerHTML = newFooter.innerHTML;
      }
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };

  /* =========================================================
     NORMALISER
     - If no eligible furniture => remove all warranty
     - If warranty present => keep ONLY ONE correct tier, qty=1
  ========================================================= */
  const normaliseWarranty = async (cartInput = null) => {
    const cart = cartInput || await getCart();
    const warrantyLines = getProtectItems(cart);

    // If no eligible furniture, remove all warranty lines
    if (!hasEligibleFurniture(cart)) {
      if (warrantyLines.length) await removeAllWarranty(cart);
      return;
    }

    // If none present, nothing to normalise
    if (!warrantyLines.length) return;

    const tier = findTier(getEligibleSubtotal(cart));
    const correctId = String(tier.variantId);

    let keptOne = false;

    for (const w of warrantyLines) {
      const vid = String(w.variant_id ?? w.id);

      // keep ONE correct line only, enforce qty=1
      if (vid === correctId && !keptOne) {
        keptOne = true;
        if (Number(w.quantity) !== 1) await changeByKey(w.key, 1);
        continue;
      }

      // remove duplicates / wrong tiers
      await changeByKey(w.key, 0);
    }
  };

  /* =========================================================
     UI SYNC
  ========================================================= */
  const getEls = () => {
    const root = document.querySelector('[data-warranty-upsell]');
    if (!root) return {};
    return {
      root,
      toggle: root.querySelector('[data-warranty-toggle]'),
      priceEl: root.querySelector('[data-warranty-price]'),
      row: root.closest('.pfp-protect6-row')
    };
  };

  const setCopy = (el, enabled, label) => {
    if (!el) return;
    el.textContent = enabled
      ? `6-year protection added to your order (${label})`
      : `Add 6-year protection to your order for ${label}`;
  };

  const syncUI = async () => {
    const { toggle, priceEl, row } = getEls();
    if (!toggle || !priceEl) return;

    const cart = await getCart();

    // Hide upsell if no eligible furniture
    if (!hasEligibleFurniture(cart)) {
      if (row) row.style.display = 'none';
      toggle.checked = false;
      priceEl.textContent = '—';
      return;
    } else if (row) {
      row.style.display = '';
    }

    const tier = findTier(getEligibleSubtotal(cart));
    const hasWarranty = getProtectItems(cart).length > 0;

    toggle.checked = hasWarranty;
    setCopy(priceEl, hasWarranty, tier.label);
  };

  /* =========================================================
     TOGGLE HANDLER (ONLY PLACE WE ADD/REMOVE)
     - no full reload
     - avoids flashing
  ========================================================= */
  document.addEventListener('change', async (e) => {
    if (!e.target || !e.target.matches('[data-warranty-toggle]')) return;

    if (window.__pfp_protect6_busy) return;
    window.__pfp_protect6_busy = true;

    const { toggle, priceEl } = getEls();
    if (!toggle) {
      window.__pfp_protect6_busy = false;
      return;
    }

    toggle.disabled = true;
    document.documentElement.classList.add('pfp-protect6-working');

    try {
      const cart = await getCart();

      // If cart has no eligible furniture, ensure warranty removed + refresh sections
      if (!hasEligibleFurniture(cart)) {
        await normaliseWarranty(cart);
        toggle.checked = false;
        await refreshCartPage();
        await syncUI().catch(() => {});
        return;
      }

      const tier = findTier(getEligibleSubtotal(cart));
      setCopy(priceEl, toggle.checked, tier.label);

      if (toggle.checked) {
        // Remove any existing warranty lines ONCE (prevents double add)
        await removeAllWarranty(cart);

        // Add correct tier ONCE
        await addVariant(tier.variantId);

        // Normalise ONCE (qty=1 / remove any surprise duplicates)
        await normaliseWarranty();
      } else {
        // Toggle off: remove all warranty lines
        await removeAllWarranty(cart);
      }

      // Refresh cart sections (no white flash)
      await refreshCartPage();

      // Re-sync UI after refresh
      await syncUI().catch(() => {});
      return;

    } catch (err) {
      console.error('[Protect6] toggle error:', err);
      toggle.checked = !toggle.checked;
      await syncUI().catch(() => {});
      alert(err?.message || 'Couldn’t update Protect6');
    } finally {
      toggle.disabled = false;
      document.documentElement.classList.remove('pfp-protect6-working');
      window.__pfp_protect6_busy = false;
    }
  });

  /* =========================================================
     AUTO CLEANUP: if user removes the last eligible product,
     remove warranty lines so they can't get stuck at checkout.
     (NO FULL RELOAD)
  ========================================================= */
  const hookCartMutations = () => {
    if (window.__pfp_protect6_cart_hooked) return;
    window.__pfp_protect6_cart_hooked = true;

    const isCartUrl = (url) =>
      url.includes('/cart/change') ||
      url.includes('/cart/update') ||
      url.includes('/cart/add') ||
      url.includes('/cart/clear');

    const run = async () => {
      if (window.__pfp_protect6_busy) return;

      const cart = await getCart().catch(() => null);
      if (!cart) return;

      // if no eligible furniture, remove warranty and refresh sections
      if (!hasEligibleFurniture(cart) && getProtectItems(cart).length) {
        await removeAllWarranty(cart).catch(() => {});
        await refreshCartPage().catch(() => {});
        await syncUI().catch(() => {});
      }
    };

    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const res = await originalFetch(...args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
        if (url && isCartUrl(url)) setTimeout(run, 250);
      } catch (_) {}
      return res;
    };

    const origOpen = XMLHttpRequest.prototype.open;
    const origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.__pfp_url = url;
      return origOpen.call(this, method, url, ...rest);
    };

    XMLHttpRequest.prototype.send = function (...args) {
      this.addEventListener('load', () => {
        try {
          const url = this.__pfp_url || '';
          if (url && isCartUrl(url)) setTimeout(run, 250);
        } catch (_) {}
      });
      return origSend.apply(this, args);
    };
  };

  /* =========================================================
     INIT
  ========================================================= */
  const init = async () => {
    hookCartMutations();
    await normaliseWarranty().catch(() => {});
    await refreshCartPage().catch(() => {}); // ensure UI + totals consistent on load
    await syncUI().catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
